// Homepage Components
import LiveAuction from '../views/live';
import AuctionProjector from '../views/projector';
import LoginUser from '../views/login';
import RegisterUser from '../views/register';
import PreBid from '../views/prebid';
import PasswordForgot from '../views/password/forgot';
import PasswordReset from '../views/password/reset';
import UserAccount from '../views/account';
import VerifyUser from '../views/verify';
import VerifyPending from '../views/verify-pending';

// Sample Pages
import error404 from '../views/sample-pages/error-404.vue';
import error500 from '../views/sample-pages/error-500.vue';

export default [
    {
        path: '/auction/:id',
        name: 'auction-live',
        component: LiveAuction,
    },
    {
        path: '/prebid/:id',
        name: 'prebid',
        component: PreBid,
        meta: {
            requiresAuth: true,
            requiresVerification: true
        }
    },
    {
        path: '/projector/:id',
        name: 'auction-projector',
        component: AuctionProjector,
    },
    {
        path: '/login',
        name: 'login',
        component: LoginUser,
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterUser,
    },
    {
        path: '/password/forgot',
        name: 'password-forgot',
        component: PasswordForgot
    },
    {
        path: '/password/reset/:token',
        name: 'password-reset',
        component: PasswordReset
    },
    {
        path: '/account',
        name: 'account',
        component: UserAccount,
        meta: {
            requiresAuth: true,
            requiresVerification: true
        }
    },
    {
        path: '/verify',
        name: 'account-verify',
        component: VerifyUser,
        meta: {
            requiresAuth: true,
            requiresNoPendingVerification: true
        }
    },
    {
        path: '/verify-pending',
        name: 'account-verify-pending',
        component: VerifyPending,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/500',
        name: 'error-500',
        component: error500,
    },
    {
        path: '*',
        name: 'error-400',
        component: error404,
    },
]



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/router/routes.ts